import { InfoDocTypes } from "../../../CoStar/Api/FusionSearch/index.js";
/** CoStar.Api.CommonViewModels.InfoDocTypes */
export { InfoDocTypes };
